var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoCapacitadores(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.248,
    height: 67,
    viewBox: "0 0 68.248 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_179",
    x: 1.248,
    y: 0,
    width: 67,
    height: 67,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12873",
    "data-name": "Trazado 12873",
    d: "M34.614,0A27.905,27.905,0,0,0,18.3,5.3H0V38.09H8.641a27.956,27.956,0,0,0,52.085,0h1.9V5.3H51.06A27.842,27.842,0,0,0,34.767,0Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ilustracion_capacitadores",
    "data-name": "Ilustracion capacitadores",
    transform: "translate(-47.898 -283.178)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 47.9, 283.18)",
    filter: "url(#Elipse_179)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_179-2",
    "data-name": "Elipse 179",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(7.25 3)",
    fill: "#ffdede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19770",
    "data-name": "Grupo 19770",
    transform: "translate(47.898 285.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19769",
    "data-name": "Grupo 19769",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12791",
    "data-name": "Trazado 12791",
    d: "M173.788,86.275H150.7a1.914,1.914,0,0,1-1.914-1.914V50.718A1.914,1.914,0,0,1,150.7,48.8h23.088a1.914,1.914,0,0,1,1.914,1.914V84.361a1.914,1.914,0,0,1-1.914,1.914",
    transform: "translate(-114.103 -37.428)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12792",
    "data-name": "Trazado 12792",
    d: "M175.782,87.924h-21.62a1.819,1.819,0,0,1-1.818-1.818V53.693a1.819,1.819,0,0,1,1.818-1.818h21.62a1.819,1.819,0,0,1,1.818,1.818V86.105a1.819,1.819,0,0,1-1.818,1.818",
    transform: "translate(-116.832 -39.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22366",
    "data-name": "Rect\\xE1ngulo 22366",
    width: 22.971,
    height: 0.241,
    transform: "translate(36.743 19.798)",
    fill: "#98005b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22367",
    "data-name": "Rect\\xE1ngulo 22367",
    width: 22.971,
    height: 0.241,
    transform: "translate(36.743 21.163)",
    fill: "#98005b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22368",
    "data-name": "Rect\\xE1ngulo 22368",
    width: 22.971,
    height: 0.241,
    transform: "translate(36.743 22.683)",
    fill: "#98005b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22369",
    "data-name": "Rect\\xE1ngulo 22369",
    width: 22.971,
    height: 0.241,
    transform: "translate(36.743 24.204)",
    fill: "#98005b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22370",
    "data-name": "Rect\\xE1ngulo 22370",
    width: 0.765,
    height: 1.973,
    transform: "translate(46.655 14.797)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12793",
    "data-name": "Trazado 12793",
    d: "M222.28,63.833v-.362h-2.617v1.973h2.617v-.366h-1.852v-.439h1.852v-.362h-1.852v-.443Z",
    transform: "translate(-168.459 -48.675)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12794",
    "data-name": "Trazado 12794",
    d: "M207.277,63.476v1.168l-1.53-1.168h-.765v1.973h.765V64.282l1.53,1.168h.765V63.476Z",
    transform: "translate(-157.2 -48.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12795",
    "data-name": "Trazado 12795",
    d: "M186.026,69.2h-2.6l-.524.169h3.648Zm-2.6.04h2.6l.161.064h-2.923Z",
    transform: "translate(-140.267 -53.067)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12796",
    "data-name": "Trazado 12796",
    d: "M186.006,63.449h1.3a8.343,8.343,0,0,1,.783-.59,3.9,3.9,0,0,1-1.286-1.293,4.421,4.421,0,0,0-1.317,1.292,3.818,3.818,0,0,0,.521.592",
    transform: "translate(-142.248 -47.215)",
    fill: "#d4007f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12797",
    "data-name": "Trazado 12797",
    d: "M188.226,70.1a3.808,3.808,0,0,0,.612.425q.216-.221.447-.425Z",
    transform: "translate(-144.35 -53.756)",
    fill: "#d4007f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22371",
    "data-name": "Rect\\xE1ngulo 22371",
    width: 0.166,
    height: 0.535,
    transform: "translate(42.639 17.211)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12798",
    "data-name": "Trazado 12798",
    d: "M184.093,74.438h.138V74.5a.2.2,0,0,1,.063-.055.163.163,0,0,1,.077-.017.127.127,0,0,1,.1.037.159.159,0,0,1,.035.113v.246h-.149v-.213a.079.079,0,0,0-.014-.052.049.049,0,0,0-.038-.015.054.054,0,0,0-.044.021.118.118,0,0,0-.017.073v.186h-.148Z",
    transform: "translate(-141.18 -57.079)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12799",
    "data-name": "Trazado 12799",
    d: "M186.117,74.717l.147-.014a.073.073,0,0,0,.025.038.077.077,0,0,0,.044.011.073.073,0,0,0,.046-.013.028.028,0,0,0,.013-.024.027.027,0,0,0-.017-.025.3.3,0,0,0-.064-.015.65.65,0,0,1-.107-.025.113.113,0,0,1-.051-.039.106.106,0,0,1,0-.128.13.13,0,0,1,.061-.041.327.327,0,0,1,.1-.014.365.365,0,0,1,.1.01.135.135,0,0,1,.055.033.171.171,0,0,1,.037.06l-.141.014a.048.048,0,0,0-.018-.028.075.075,0,0,0-.042-.012.061.061,0,0,0-.037.009.027.027,0,0,0-.011.022.023.023,0,0,0,.014.022.25.25,0,0,0,.063.013.434.434,0,0,1,.11.023.119.119,0,0,1,.055.042.105.105,0,0,1,.019.061.12.12,0,0,1-.02.065.135.135,0,0,1-.064.05.3.3,0,0,1-.119.019.28.28,0,0,1-.151-.03.135.135,0,0,1-.058-.086",
    transform: "translate(-142.732 -57.079)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12800",
    "data-name": "Trazado 12800",
    d: "M188.283,73.834v.147h.082v.109h-.082v.137a.077.077,0,0,0,0,.033.028.028,0,0,0,.026.012.165.165,0,0,0,.046-.01l.011.1a.477.477,0,0,1-.1.012.178.178,0,0,1-.082-.014.086.086,0,0,1-.039-.043.254.254,0,0,1-.013-.094V74.09h-.055v-.109h.055V73.91Z",
    transform: "translate(-144.238 -56.623)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12801",
    "data-name": "Trazado 12801",
    d: "M189.63,73.834h.148v.1h-.148Zm0,.147h.148v.387h-.148Z",
    transform: "translate(-145.426 -56.623)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12802",
    "data-name": "Trazado 12802",
    d: "M190.773,73.834v.147h.082v.109h-.082v.137a.077.077,0,0,0,0,.033.027.027,0,0,0,.026.012.165.165,0,0,0,.046-.01l.011.1a.477.477,0,0,1-.1.012.178.178,0,0,1-.082-.014.086.086,0,0,1-.039-.043.254.254,0,0,1-.013-.094V74.09h-.055v-.109h.055V73.91Z",
    transform: "translate(-146.146 -56.623)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12803",
    "data-name": "Trazado 12803",
    d: "M192.5,74.853h-.138V74.79a.207.207,0,0,1-.062.055.166.166,0,0,1-.078.017.126.126,0,0,1-.1-.037.159.159,0,0,1-.035-.113v-.246h.149v.213a.078.078,0,0,0,.013.052.048.048,0,0,0,.038.015.054.054,0,0,0,.044-.021.118.118,0,0,0,.017-.073v-.186h.148Z",
    transform: "translate(-147.312 -57.108)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12804",
    "data-name": "Trazado 12804",
    d: "M194.329,73.834v.147h.082v.109h-.082v.137a.077.077,0,0,0,0,.033.028.028,0,0,0,.026.012.165.165,0,0,0,.046-.01l.011.1a.477.477,0,0,1-.1.012.179.179,0,0,1-.082-.014.086.086,0,0,1-.039-.043.254.254,0,0,1-.013-.094V74.09h-.055v-.109h.055V73.91Z",
    transform: "translate(-148.874 -56.623)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12805",
    "data-name": "Trazado 12805",
    d: "M195.575,74.632a.194.194,0,0,1,.06-.146.26.26,0,0,1,.337.01.211.211,0,0,1-.011.28.227.227,0,0,1-.164.057.23.23,0,0,1-.151-.048.19.19,0,0,1-.071-.154m.149,0a.116.116,0,0,0,.021.076.068.068,0,0,0,.105,0,.121.121,0,0,0,.021-.078.114.114,0,0,0-.021-.075.065.065,0,0,0-.051-.024.067.067,0,0,0-.054.025.115.115,0,0,0-.021.076",
    transform: "translate(-149.986 -57.079)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12806",
    "data-name": "Trazado 12806",
    d: "M198.9,73.834h.154l.2.3v-.3h.156v.535h-.156l-.2-.293v.293H198.9Z",
    transform: "translate(-152.539 -56.623)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12807",
    "data-name": "Trazado 12807",
    d: "M201.6,74.563l-.142-.015a.162.162,0,0,1,.023-.059.126.126,0,0,1,.044-.037.177.177,0,0,1,.056-.018.469.469,0,0,1,.077-.006.6.6,0,0,1,.107.007.136.136,0,0,1,.067.031.111.111,0,0,1,.03.046.169.169,0,0,1,.011.057v.171a.225.225,0,0,0,0,.043.2.2,0,0,0,.015.039h-.139a.133.133,0,0,1-.011-.023.2.2,0,0,1-.005-.024.19.19,0,0,1-.058.04.242.242,0,0,1-.092.016.152.152,0,0,1-.105-.032.1.1,0,0,1-.036-.079.1.1,0,0,1,.026-.073.174.174,0,0,1,.1-.042c.056-.011.092-.019.108-.024a.513.513,0,0,0,.053-.017.053.053,0,0,0-.011-.038.057.057,0,0,0-.04-.011.1.1,0,0,0-.055.012.064.064,0,0,0-.023.034m.129.078c-.021.007-.042.014-.064.019a.144.144,0,0,0-.057.024.038.038,0,0,0,0,.056.052.052,0,0,0,.036.011.093.093,0,0,0,.046-.012.075.075,0,0,0,.03-.029.1.1,0,0,0,.009-.045Z",
    transform: "translate(-154.489 -57.079)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12808",
    "data-name": "Trazado 12808",
    d: "M203.892,74.672l.141.016a.2.2,0,0,1-.038.076.178.178,0,0,1-.068.05.266.266,0,0,1-.105.018.386.386,0,0,1-.1-.011.178.178,0,0,1-.07-.037.185.185,0,0,1-.046-.06.255.255,0,0,1,0-.191.179.179,0,0,1,.041-.052.187.187,0,0,1,.053-.034.3.3,0,0,1,.111-.018.256.256,0,0,1,.145.034.18.18,0,0,1,.07.1l-.14.019a.064.064,0,0,0-.024-.037.075.075,0,0,0-.046-.013.074.074,0,0,0-.06.026.119.119,0,0,0-.023.08.1.1,0,0,0,.023.072.074.074,0,0,0,.058.025.079.079,0,0,0,.049-.015.09.09,0,0,0,.03-.046",
    transform: "translate(-156.128 -57.078)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12809",
    "data-name": "Trazado 12809",
    d: "M205.821,73.834h.148v.1h-.148Zm0,.147h.148v.387h-.148Z",
    transform: "translate(-157.843 -56.623)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12810",
    "data-name": "Trazado 12810",
    d: "M206.786,74.632a.194.194,0,0,1,.06-.146.26.26,0,0,1,.337.01.211.211,0,0,1-.011.28.227.227,0,0,1-.164.057.23.23,0,0,1-.151-.048.19.19,0,0,1-.071-.154m.149,0a.116.116,0,0,0,.021.076.069.069,0,0,0,.105,0,.121.121,0,0,0,.021-.078.115.115,0,0,0-.021-.075.065.065,0,0,0-.052-.024.068.068,0,0,0-.054.025.116.116,0,0,0-.021.076",
    transform: "translate(-158.583 -57.079)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12811",
    "data-name": "Trazado 12811",
    d: "M209,74.438h.138V74.5a.206.206,0,0,1,.063-.055.164.164,0,0,1,.077-.017.127.127,0,0,1,.1.037.159.159,0,0,1,.035.113v.246h-.149v-.213a.078.078,0,0,0-.014-.052.048.048,0,0,0-.038-.015.054.054,0,0,0-.044.021.118.118,0,0,0-.017.073v.186H209Z",
    transform: "translate(-160.282 -57.079)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12812",
    "data-name": "Trazado 12812",
    d: "M211.212,74.563l-.142-.015a.161.161,0,0,1,.023-.059.123.123,0,0,1,.044-.037.177.177,0,0,1,.056-.018.469.469,0,0,1,.077-.006.6.6,0,0,1,.107.007.137.137,0,0,1,.067.031.109.109,0,0,1,.03.046.164.164,0,0,1,.011.057v.171a.2.2,0,0,0,0,.043.2.2,0,0,0,.015.039h-.139a.105.105,0,0,1-.011-.023.163.163,0,0,1-.005-.024.191.191,0,0,1-.058.04.24.24,0,0,1-.091.016.153.153,0,0,1-.105-.032.109.109,0,0,1-.01-.152.174.174,0,0,1,.1-.042c.056-.011.092-.019.108-.024a.514.514,0,0,0,.053-.017.052.052,0,0,0-.012-.038.056.056,0,0,0-.04-.011.1.1,0,0,0-.055.012.066.066,0,0,0-.023.034m.129.078c-.021.007-.042.014-.064.019a.144.144,0,0,0-.057.024.037.037,0,0,0,0,.056.052.052,0,0,0,.036.011.1.1,0,0,0,.046-.012.073.073,0,0,0,.03-.029.094.094,0,0,0,.009-.045Z",
    transform: "translate(-161.859 -57.079)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22372",
    "data-name": "Rect\\xE1ngulo 22372",
    width: 0.149,
    height: 0.535,
    transform: "translate(49.72 17.211)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12813",
    "data-name": "Trazado 12813",
    d: "M215.448,73.834h.443v.114h-.277v.085h.257v.109h-.257v.105h.285v.121h-.451Z",
    transform: "translate(-165.226 -56.623)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22373",
    "data-name": "Rect\\xE1ngulo 22373",
    width: 0.149,
    height: 0.535,
    transform: "translate(50.757 17.211)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12814",
    "data-name": "Trazado 12814",
    d: "M219.156,74.668h-.3a.1.1,0,0,0,.02.053.07.07,0,0,0,.056.025.086.086,0,0,0,.042-.011.093.093,0,0,0,.026-.024l.146.013a.207.207,0,0,1-.081.084.293.293,0,0,1-.136.025.278.278,0,0,1-.121-.022.179.179,0,0,1-.073-.069.209.209,0,0,1-.029-.111.2.2,0,0,1,.058-.147.222.222,0,0,1,.161-.056.285.285,0,0,1,.131.025.169.169,0,0,1,.073.073.266.266,0,0,1,.025.124Zm-.151-.071a.1.1,0,0,0-.023-.062.073.073,0,0,0-.106.009.1.1,0,0,0-.017.052Z",
    transform: "translate(-167.726 -57.079)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12815",
    "data-name": "Trazado 12815",
    d: "M221.154,74.672l.141.016a.2.2,0,0,1-.038.076.179.179,0,0,1-.068.05.268.268,0,0,1-.105.018.387.387,0,0,1-.1-.011.18.18,0,0,1-.071-.037.187.187,0,0,1-.046-.06.212.212,0,0,1-.017-.092.216.216,0,0,1,.02-.1.183.183,0,0,1,.041-.052.188.188,0,0,1,.053-.034.3.3,0,0,1,.111-.018.256.256,0,0,1,.145.034.178.178,0,0,1,.07.1l-.14.019a.063.063,0,0,0-.024-.037.076.076,0,0,0-.046-.013.074.074,0,0,0-.06.026.119.119,0,0,0-.023.08.1.1,0,0,0,.023.072.074.074,0,0,0,.058.025.08.08,0,0,0,.049-.015.09.09,0,0,0,.03-.046",
    transform: "translate(-169.366 -57.078)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12816",
    "data-name": "Trazado 12816",
    d: "M223.158,73.834v.147h.082v.109h-.082v.137a.077.077,0,0,0,0,.033.028.028,0,0,0,.026.012.165.165,0,0,0,.046-.01l.011.1a.477.477,0,0,1-.1.012.179.179,0,0,1-.082-.014.086.086,0,0,1-.039-.043.254.254,0,0,1-.013-.094V74.09h-.055v-.109h.055V73.91Z",
    transform: "translate(-170.983 -56.623)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12817",
    "data-name": "Trazado 12817",
    d: "M224.4,74.632a.193.193,0,0,1,.06-.146.259.259,0,0,1,.337.01.2.2,0,0,1,.048.134.194.194,0,0,1-.059.146.226.226,0,0,1-.164.057.23.23,0,0,1-.151-.048.19.19,0,0,1-.07-.154m.149,0a.116.116,0,0,0,.021.076.068.068,0,0,0,.105,0,.122.122,0,0,0,.021-.078.115.115,0,0,0-.021-.075.065.065,0,0,0-.052-.024.067.067,0,0,0-.053.025.116.116,0,0,0-.021.076",
    transform: "translate(-172.094 -57.079)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12818",
    "data-name": "Trazado 12818",
    d: "M226.624,74.438h.139V74.5a.152.152,0,0,1,.041-.057.089.089,0,0,1,.053-.015.158.158,0,0,1,.072.02l-.046.106a.115.115,0,0,0-.042-.011.051.051,0,0,0-.045.024.246.246,0,0,0-.023.127v.13h-.149Z",
    transform: "translate(-173.797 -57.079)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12819",
    "data-name": "Trazado 12819",
    d: "M228.169,74.563l-.142-.015a.162.162,0,0,1,.023-.059.125.125,0,0,1,.044-.037.179.179,0,0,1,.056-.018.469.469,0,0,1,.077-.006.6.6,0,0,1,.107.007.137.137,0,0,1,.068.031.109.109,0,0,1,.03.046.169.169,0,0,1,.011.057v.171a.206.206,0,0,0,0,.043.176.176,0,0,0,.015.039h-.139a.135.135,0,0,1-.011-.023.172.172,0,0,1,0-.024.194.194,0,0,1-.058.04.242.242,0,0,1-.092.016.153.153,0,0,1-.105-.032.1.1,0,0,1-.036-.079.1.1,0,0,1,.026-.073.174.174,0,0,1,.1-.042c.055-.011.092-.019.108-.024a.494.494,0,0,0,.052-.017.053.053,0,0,0-.011-.038.057.057,0,0,0-.04-.011.1.1,0,0,0-.055.012.064.064,0,0,0-.023.034m.129.078c-.02.007-.041.014-.064.019a.144.144,0,0,0-.057.024.036.036,0,0,0-.012.027.036.036,0,0,0,.012.028.051.051,0,0,0,.036.011.093.093,0,0,0,.046-.012.074.074,0,0,0,.03-.029.1.1,0,0,0,.009-.045Z",
    transform: "translate(-174.864 -57.079)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22374",
    "data-name": "Rect\\xE1ngulo 22374",
    width: 0.149,
    height: 0.535,
    transform: "translate(53.673 17.211)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22375",
    "data-name": "Rect\\xE1ngulo 22375",
    width: 6.063,
    height: 6.092,
    transform: "translate(38.217 28.423)",
    fill: "#d10f7f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22376",
    "data-name": "Rect\\xE1ngulo 22376",
    width: 6.063,
    height: 1.178,
    transform: "translate(38.217 27.245)",
    fill: "#e498c1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22377",
    "data-name": "Rect\\xE1ngulo 22377",
    width: 2.391,
    height: 0.187,
    transform: "translate(40.02 27.719)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22378",
    "data-name": "Rect\\xE1ngulo 22378",
    width: 4.282,
    height: 4.311,
    transform: "translate(39.107 29.313)",
    fill: "#f3cbe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12820",
    "data-name": "Trazado 12820",
    d: "M172.049,125.752v1.939l-2.372,2.372h-1.911v-1.7l2.612-2.612Z",
    transform: "translate(-128.659 -96.439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22379",
    "data-name": "Rect\\xE1ngulo 22379",
    width: 13.349,
    height: 0.241,
    transform: "translate(46.365 28.499)",
    fill: "#98005b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22380",
    "data-name": "Rect\\xE1ngulo 22380",
    width: 13.349,
    height: 0.241,
    transform: "translate(46.365 29.864)",
    fill: "#98005b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22381",
    "data-name": "Rect\\xE1ngulo 22381",
    width: 13.349,
    height: 0.241,
    transform: "translate(46.365 31.384)",
    fill: "#98005b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22382",
    "data-name": "Rect\\xE1ngulo 22382",
    width: 13.349,
    height: 0.241,
    transform: "translate(46.365 32.905)",
    fill: "#98005b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22383",
    "data-name": "Rect\\xE1ngulo 22383",
    width: 11.397,
    height: 0.241,
    transform: "translate(36.743 37.97)",
    fill: "#98005b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22384",
    "data-name": "Rect\\xE1ngulo 22384",
    width: 11.397,
    height: 0.241,
    transform: "translate(36.743 39.334)",
    fill: "#98005b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22385",
    "data-name": "Rect\\xE1ngulo 22385",
    width: 11.397,
    height: 0.241,
    transform: "translate(36.743 40.855)",
    fill: "#98005b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22386",
    "data-name": "Rect\\xE1ngulo 22386",
    width: 11.397,
    height: 0.241,
    transform: "translate(36.743 42.375)",
    fill: "#98005b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22387",
    "data-name": "Rect\\xE1ngulo 22387",
    width: 9.965,
    height: 8.616,
    transform: "translate(49.449 36.269)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22388",
    "data-name": "Rect\\xE1ngulo 22388",
    width: 0.315,
    height: 8.35,
    transform: "translate(59.01 36.397)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22389",
    "data-name": "Rect\\xE1ngulo 22389",
    width: 9.622,
    height: 8.353,
    transform: "translate(49.556 36.397)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22390",
    "data-name": "Rect\\xE1ngulo 22390",
    width: 0.616,
    height: 0.917,
    transform: "translate(50.141 43.143)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12821",
    "data-name": "Trazado 12821",
    d: "M215.1,186.234v-.339a.437.437,0,0,1,.181-.205l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.151.093.175.194v.35Z",
    transform: "translate(-164.959 -142.174)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22391",
    "data-name": "Rect\\xE1ngulo 22391",
    width: 0.437,
    height: 0.052,
    transform: "translate(50.974 43.268)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22392",
    "data-name": "Rect\\xE1ngulo 22392",
    width: 0.726,
    height: 0.052,
    transform: "translate(50.974 43.576)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22393",
    "data-name": "Rect\\xE1ngulo 22393",
    width: 0.437,
    height: 0.052,
    transform: "translate(50.974 43.883)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22394",
    "data-name": "Rect\\xE1ngulo 22394",
    width: 0.616,
    height: 0.917,
    transform: "translate(50.141 41.938)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12822",
    "data-name": "Trazado 12822",
    d: "M215.1,181.064v-.339a.436.436,0,0,1,.181-.2l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.151.093.175.193v.351Z",
    transform: "translate(-164.959 -138.209)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22395",
    "data-name": "Rect\\xE1ngulo 22395",
    width: 0.437,
    height: 0.052,
    transform: "translate(50.974 42.063)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22396",
    "data-name": "Rect\\xE1ngulo 22396",
    width: 0.726,
    height: 0.052,
    transform: "translate(50.974 42.37)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22397",
    "data-name": "Rect\\xE1ngulo 22397",
    width: 0.726,
    height: 0.052,
    transform: "translate(50.974 42.678)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22398",
    "data-name": "Rect\\xE1ngulo 22398",
    width: 0.616,
    height: 0.917,
    transform: "translate(50.141 40.733)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12823",
    "data-name": "Trazado 12823",
    d: "M215.1,175.892v-.339a.437.437,0,0,1,.181-.205l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.152v.149s.151.093.175.193v.351Z",
    transform: "translate(-164.959 -134.243)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22399",
    "data-name": "Rect\\xE1ngulo 22399",
    width: 0.437,
    height: 0.052,
    transform: "translate(50.974 40.857)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22400",
    "data-name": "Rect\\xE1ngulo 22400",
    width: 0.726,
    height: 0.052,
    transform: "translate(50.974 41.165)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22401",
    "data-name": "Rect\\xE1ngulo 22401",
    width: 0.726,
    height: 0.052,
    transform: "translate(50.974 41.473)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12824",
    "data-name": "Trazado 12824",
    d: "M215.1,170.721v-.339a.436.436,0,0,1,.181-.205l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.151.093.175.193v.351Z",
    transform: "translate(-164.959 -130.277)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22402",
    "data-name": "Rect\\xE1ngulo 22402",
    width: 0.726,
    height: 0.052,
    transform: "translate(50.974 39.652)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22403",
    "data-name": "Rect\\xE1ngulo 22403",
    width: 0.726,
    height: 0.052,
    transform: "translate(50.974 39.96)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22404",
    "data-name": "Rect\\xE1ngulo 22404",
    width: 0.616,
    height: 0.917,
    transform: "translate(50.141 39.527)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12825",
    "data-name": "Trazado 12825",
    d: "M215.1,170.721v-.339a.436.436,0,0,1,.181-.205l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.151.093.175.193v.351Z",
    transform: "translate(-164.959 -130.277)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22405",
    "data-name": "Rect\\xE1ngulo 22405",
    width: 0.726,
    height: 0.052,
    transform: "translate(50.974 39.652)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22406",
    "data-name": "Rect\\xE1ngulo 22406",
    width: 0.437,
    height: 0.052,
    transform: "translate(50.974 40.267)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22407",
    "data-name": "Rect\\xE1ngulo 22407",
    width: 0.616,
    height: 0.917,
    transform: "translate(50.141 38.322)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12826",
    "data-name": "Trazado 12826",
    d: "M215.1,165.551v-.339a.437.437,0,0,1,.181-.205l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.151.093.175.193v.351Z",
    transform: "translate(-164.959 -126.312)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22408",
    "data-name": "Rect\\xE1ngulo 22408",
    width: 0.437,
    height: 0.052,
    transform: "translate(50.974 38.447)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22409",
    "data-name": "Rect\\xE1ngulo 22409",
    width: 0.437,
    height: 0.052,
    transform: "translate(50.974 38.754)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22410",
    "data-name": "Rect\\xE1ngulo 22410",
    width: 0.726,
    height: 0.052,
    transform: "translate(50.974 39.062)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22411",
    "data-name": "Rect\\xE1ngulo 22411",
    width: 0.616,
    height: 0.917,
    transform: "translate(50.141 37.117)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12827",
    "data-name": "Trazado 12827",
    d: "M215.1,160.38v-.339a.436.436,0,0,1,.181-.2l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.151.093.175.193v.351Z",
    transform: "translate(-164.959 -122.347)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22412",
    "data-name": "Rect\\xE1ngulo 22412",
    width: 0.61,
    height: 0.052,
    transform: "translate(50.974 37.241)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22413",
    "data-name": "Rect\\xE1ngulo 22413",
    width: 0.726,
    height: 0.052,
    transform: "translate(50.974 37.549)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22414",
    "data-name": "Rect\\xE1ngulo 22414",
    width: 0.726,
    height: 0.052,
    transform: "translate(50.974 37.856)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22415",
    "data-name": "Rect\\xE1ngulo 22415",
    width: 0.616,
    height: 0.917,
    transform: "translate(52.493 43.143)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12828",
    "data-name": "Trazado 12828",
    d: "M225.193,186.234v-.339a.436.436,0,0,1,.181-.205l0-.148a.136.136,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.151.093.174.194v.35Z",
    transform: "translate(-172.699 -142.174)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22416",
    "data-name": "Rect\\xE1ngulo 22416",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 43.268)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22417",
    "data-name": "Rect\\xE1ngulo 22417",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 43.576)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22418",
    "data-name": "Rect\\xE1ngulo 22418",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 43.883)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22419",
    "data-name": "Rect\\xE1ngulo 22419",
    width: 0.616,
    height: 0.917,
    transform: "translate(52.493 41.938)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12829",
    "data-name": "Trazado 12829",
    d: "M225.193,181.064v-.339a.435.435,0,0,1,.181-.2l0-.148a.136.136,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.151.093.174.193v.351Z",
    transform: "translate(-172.699 -138.209)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22420",
    "data-name": "Rect\\xE1ngulo 22420",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 42.063)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22421",
    "data-name": "Rect\\xE1ngulo 22421",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 42.37)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22422",
    "data-name": "Rect\\xE1ngulo 22422",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 42.678)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22423",
    "data-name": "Rect\\xE1ngulo 22423",
    width: 0.616,
    height: 0.917,
    transform: "translate(52.493 40.733)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12830",
    "data-name": "Trazado 12830",
    d: "M225.193,175.892v-.339a.436.436,0,0,1,.181-.205l0-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.152v.149s.151.093.174.193v.351Z",
    transform: "translate(-172.699 -134.243)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22424",
    "data-name": "Rect\\xE1ngulo 22424",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 40.857)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22425",
    "data-name": "Rect\\xE1ngulo 22425",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 41.165)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22426",
    "data-name": "Rect\\xE1ngulo 22426",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 41.473)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12831",
    "data-name": "Trazado 12831",
    d: "M225.193,170.721v-.339a.435.435,0,0,1,.181-.205l0-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.151.093.174.193v.351Z",
    transform: "translate(-172.699 -130.277)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22427",
    "data-name": "Rect\\xE1ngulo 22427",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 39.652)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22428",
    "data-name": "Rect\\xE1ngulo 22428",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 39.96)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22429",
    "data-name": "Rect\\xE1ngulo 22429",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 40.267)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12832",
    "data-name": "Trazado 12832",
    d: "M225.193,170.721v-.339a.435.435,0,0,1,.181-.205l0-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.151.093.174.193v.351Z",
    transform: "translate(-172.699 -130.277)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22430",
    "data-name": "Rect\\xE1ngulo 22430",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 39.652)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22431",
    "data-name": "Rect\\xE1ngulo 22431",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 39.96)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22432",
    "data-name": "Rect\\xE1ngulo 22432",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 40.267)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22433",
    "data-name": "Rect\\xE1ngulo 22433",
    width: 0.616,
    height: 0.917,
    transform: "translate(52.493 38.322)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12833",
    "data-name": "Trazado 12833",
    d: "M225.193,165.551v-.339a.436.436,0,0,1,.181-.205l0-.148a.136.136,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.151.093.174.193v.351Z",
    transform: "translate(-172.699 -126.312)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22434",
    "data-name": "Rect\\xE1ngulo 22434",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 38.447)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22435",
    "data-name": "Rect\\xE1ngulo 22435",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 38.754)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22436",
    "data-name": "Rect\\xE1ngulo 22436",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 39.062)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22437",
    "data-name": "Rect\\xE1ngulo 22437",
    width: 0.616,
    height: 0.917,
    transform: "translate(52.493 37.117)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12834",
    "data-name": "Trazado 12834",
    d: "M225.193,160.38v-.339a.435.435,0,0,1,.181-.2l0-.148a.136.136,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.151.093.174.193v.351Z",
    transform: "translate(-172.699 -122.347)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22438",
    "data-name": "Rect\\xE1ngulo 22438",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 37.241)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22439",
    "data-name": "Rect\\xE1ngulo 22439",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 37.549)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22440",
    "data-name": "Rect\\xE1ngulo 22440",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 37.856)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22441",
    "data-name": "Rect\\xE1ngulo 22441",
    width: 0.616,
    height: 0.917,
    transform: "translate(54.904 43.143)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12835",
    "data-name": "Trazado 12835",
    d: "M235.533,186.234v-.339a.435.435,0,0,1,.181-.205l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.152.093.175.194v.35Z",
    transform: "translate(-180.629 -142.174)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22442",
    "data-name": "Rect\\xE1ngulo 22442",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 43.268)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22443",
    "data-name": "Rect\\xE1ngulo 22443",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 43.576)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22444",
    "data-name": "Rect\\xE1ngulo 22444",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 43.883)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22445",
    "data-name": "Rect\\xE1ngulo 22445",
    width: 0.616,
    height: 0.917,
    transform: "translate(54.904 41.938)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12836",
    "data-name": "Trazado 12836",
    d: "M235.533,181.064v-.339a.434.434,0,0,1,.181-.2l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.152.093.175.193v.351Z",
    transform: "translate(-180.629 -138.209)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22446",
    "data-name": "Rect\\xE1ngulo 22446",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 42.063)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22447",
    "data-name": "Rect\\xE1ngulo 22447",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 42.37)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22448",
    "data-name": "Rect\\xE1ngulo 22448",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 42.678)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22449",
    "data-name": "Rect\\xE1ngulo 22449",
    width: 0.616,
    height: 0.917,
    transform: "translate(54.904 40.733)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12837",
    "data-name": "Trazado 12837",
    d: "M235.533,175.892v-.339a.435.435,0,0,1,.181-.205l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.152v.149s.152.093.175.193v.351Z",
    transform: "translate(-180.629 -134.243)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22450",
    "data-name": "Rect\\xE1ngulo 22450",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 40.857)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22451",
    "data-name": "Rect\\xE1ngulo 22451",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 41.165)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22452",
    "data-name": "Rect\\xE1ngulo 22452",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 41.473)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12838",
    "data-name": "Trazado 12838",
    d: "M235.533,170.721v-.339a.434.434,0,0,1,.181-.205l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.152.093.175.193v.351Z",
    transform: "translate(-180.629 -130.277)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22453",
    "data-name": "Rect\\xE1ngulo 22453",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 39.652)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22454",
    "data-name": "Rect\\xE1ngulo 22454",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 39.96)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22455",
    "data-name": "Rect\\xE1ngulo 22455",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 40.267)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22456",
    "data-name": "Rect\\xE1ngulo 22456",
    width: 0.616,
    height: 0.917,
    transform: "translate(54.904 39.527)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12839",
    "data-name": "Trazado 12839",
    d: "M235.533,170.721v-.339a.434.434,0,0,1,.181-.205l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.152.093.175.193v.351Z",
    transform: "translate(-180.629 -130.277)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22457",
    "data-name": "Rect\\xE1ngulo 22457",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 39.652)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22458",
    "data-name": "Rect\\xE1ngulo 22458",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 39.96)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22459",
    "data-name": "Rect\\xE1ngulo 22459",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 40.267)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22460",
    "data-name": "Rect\\xE1ngulo 22460",
    width: 0.616,
    height: 0.917,
    transform: "translate(54.904 38.322)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12840",
    "data-name": "Trazado 12840",
    d: "M235.533,165.551v-.339a.435.435,0,0,1,.181-.205l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.152.093.175.193v.351Z",
    transform: "translate(-180.629 -126.312)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22461",
    "data-name": "Rect\\xE1ngulo 22461",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 38.447)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22462",
    "data-name": "Rect\\xE1ngulo 22462",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 38.754)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22463",
    "data-name": "Rect\\xE1ngulo 22463",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 39.062)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22464",
    "data-name": "Rect\\xE1ngulo 22464",
    width: 0.616,
    height: 0.917,
    transform: "translate(54.904 37.117)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12841",
    "data-name": "Trazado 12841",
    d: "M235.533,160.38v-.339a.434.434,0,0,1,.181-.2l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.152.093.175.193v.351Z",
    transform: "translate(-180.629 -122.347)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22465",
    "data-name": "Rect\\xE1ngulo 22465",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 37.241)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22466",
    "data-name": "Rect\\xE1ngulo 22466",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 37.549)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22467",
    "data-name": "Rect\\xE1ngulo 22467",
    width: 0.726,
    height: 0.052,
    transform: "translate(55.737 37.856)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22468",
    "data-name": "Rect\\xE1ngulo 22468",
    width: 0.616,
    height: 0.917,
    transform: "translate(57.314 43.143)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12842",
    "data-name": "Trazado 12842",
    d: "M245.874,186.234v-.339a.435.435,0,0,1,.181-.205l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.151.093.175.194v.35Z",
    transform: "translate(-188.56 -142.174)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22469",
    "data-name": "Rect\\xE1ngulo 22469",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 43.268)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22470",
    "data-name": "Rect\\xE1ngulo 22470",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 43.576)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22471",
    "data-name": "Rect\\xE1ngulo 22471",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 43.883)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22472",
    "data-name": "Rect\\xE1ngulo 22472",
    width: 0.616,
    height: 0.917,
    transform: "translate(57.314 41.938)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12843",
    "data-name": "Trazado 12843",
    d: "M245.874,181.064v-.339a.434.434,0,0,1,.181-.2l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.151.093.175.193v.351Z",
    transform: "translate(-188.56 -138.209)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22473",
    "data-name": "Rect\\xE1ngulo 22473",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 42.063)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22474",
    "data-name": "Rect\\xE1ngulo 22474",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 42.37)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22475",
    "data-name": "Rect\\xE1ngulo 22475",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 42.678)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22476",
    "data-name": "Rect\\xE1ngulo 22476",
    width: 0.616,
    height: 0.917,
    transform: "translate(57.314 40.733)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12844",
    "data-name": "Trazado 12844",
    d: "M245.874,175.892v-.339a.435.435,0,0,1,.181-.205l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.152v.149s.151.093.175.193v.351Z",
    transform: "translate(-188.56 -134.243)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22477",
    "data-name": "Rect\\xE1ngulo 22477",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 40.857)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22478",
    "data-name": "Rect\\xE1ngulo 22478",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 41.165)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22479",
    "data-name": "Rect\\xE1ngulo 22479",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 41.473)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12845",
    "data-name": "Trazado 12845",
    d: "M245.874,170.721v-.339a.434.434,0,0,1,.181-.205l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.151.093.175.193v.351Z",
    transform: "translate(-188.56 -130.277)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22480",
    "data-name": "Rect\\xE1ngulo 22480",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 39.652)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22481",
    "data-name": "Rect\\xE1ngulo 22481",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 39.96)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22482",
    "data-name": "Rect\\xE1ngulo 22482",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 40.267)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22483",
    "data-name": "Rect\\xE1ngulo 22483",
    width: 0.616,
    height: 0.917,
    transform: "translate(57.314 39.527)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12846",
    "data-name": "Trazado 12846",
    d: "M245.874,170.721v-.339a.434.434,0,0,1,.181-.205l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.151.093.175.193v.351Z",
    transform: "translate(-188.56 -130.277)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22484",
    "data-name": "Rect\\xE1ngulo 22484",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 39.652)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22485",
    "data-name": "Rect\\xE1ngulo 22485",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 39.96)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22486",
    "data-name": "Rect\\xE1ngulo 22486",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 40.267)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22487",
    "data-name": "Rect\\xE1ngulo 22487",
    width: 0.616,
    height: 0.917,
    transform: "translate(57.314 38.322)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12847",
    "data-name": "Trazado 12847",
    d: "M245.874,165.551v-.339a.435.435,0,0,1,.181-.205l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.151.093.175.193v.351Z",
    transform: "translate(-188.56 -126.312)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22488",
    "data-name": "Rect\\xE1ngulo 22488",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 38.447)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22489",
    "data-name": "Rect\\xE1ngulo 22489",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 38.754)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22490",
    "data-name": "Rect\\xE1ngulo 22490",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 39.062)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22491",
    "data-name": "Rect\\xE1ngulo 22491",
    width: 0.616,
    height: 0.917,
    transform: "translate(57.314 37.117)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12848",
    "data-name": "Trazado 12848",
    d: "M245.874,160.38v-.339a.434.434,0,0,1,.181-.2l-.005-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.151.093.175.193v.351Z",
    transform: "translate(-188.56 -122.347)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22492",
    "data-name": "Rect\\xE1ngulo 22492",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 37.241)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22493",
    "data-name": "Rect\\xE1ngulo 22493",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 37.549)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22494",
    "data-name": "Rect\\xE1ngulo 22494",
    width: 0.726,
    height: 0.052,
    transform: "translate(58.148 37.856)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22495",
    "data-name": "Rect\\xE1ngulo 22495",
    width: 0.616,
    height: 0.917,
    transform: "translate(52.493 39.527)",
    fill: "none",
    stroke: "#979898",
    strokeWidth: 0.127
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12849",
    "data-name": "Trazado 12849",
    d: "M225.193,170.721v-.339a.435.435,0,0,1,.181-.205l0-.148a.137.137,0,0,1,.133-.153.144.144,0,0,1,.133.151v.15s.151.093.174.193v.351Z",
    transform: "translate(-172.699 -130.277)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22496",
    "data-name": "Rect\\xE1ngulo 22496",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 39.652)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22497",
    "data-name": "Rect\\xE1ngulo 22497",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 39.96)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22498",
    "data-name": "Rect\\xE1ngulo 22498",
    width: 0.726,
    height: 0.052,
    transform: "translate(53.327 40.267)",
    fill: "#979898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12850",
    "data-name": "Trazado 12850",
    d: "M52.56,108.39H46.626a1.472,1.472,0,0,1-1.472-1.472V95.028a3.877,3.877,0,0,1,3.877-3.877h3.53a1.472,1.472,0,0,1,1.472,1.472v14.295a1.472,1.472,0,0,1-1.472,1.472",
    transform: "translate(-34.628 -69.903)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12851",
    "data-name": "Trazado 12851",
    d: "M123.806,131.53l4.267-8.357-5.024-7.486,4.771-2.481,3.762,6.407c1.319,2.268,1.8,3.862.492,5.382l-6.451,8.114Z",
    transform: "translate(-94.365 -86.818)",
    fill: "#f7a59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12852",
    "data-name": "Trazado 12852",
    d: "M124.422,190.23s-.982-.109-1.139,2.239-.746,3.893.864,4,4.36-1.237,2.484-3.129l-.7-1.991Z",
    transform: "translate(-94.365 -145.886)",
    fill: "#f7a59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12853",
    "data-name": "Trazado 12853",
    d: "M116.456,87.549s4.258.409,6.743,7.023L116.308,99.7l-1.183-4.054Z",
    transform: "translate(-88.289 -67.141)",
    fill: "#b7006d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12854",
    "data-name": "Trazado 12854",
    d: "M49.769,182.4l-2.7,40.482,8.012.066,2.813-34.285,3.056,33.569,8.728-.875L65.516,182.4Z",
    transform: "translate(-36.096 -139.885)",
    fill: "#7a4aa8"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_101",
    "data-name": "L\\xEDnea 101",
    y1: 1.018,
    x2: 2.835,
    transform: "translate(21.797 47.764)",
    fill: "none",
    stroke: "#09090b",
    strokeWidth: 0.775
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12855",
    "data-name": "Trazado 12855",
    d: "M19.745,94.759l-1.9,2.439-2.613-8.777-2.792.314L13.766,99.87a3.184,3.184,0,0,0,5.222,2.457l5.138-4.52Z",
    transform: "translate(-9.539 -67.81)",
    fill: "#ffb1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12856",
    "data-name": "Trazado 12856",
    d: "M.065,60.856a.31.31,0,0,1,.462-.033L2.1,62.63l-.673-3.091a.329.329,0,0,1,.632-.18l.983,2.78-.516-3.451a.3.3,0,0,1,.578-.119l.83,3.144-.189-2.741a.352.352,0,0,1,.376-.354c.21-.012.342.207.366.37l.481,3.845.495-1.2a.433.433,0,0,1,.853.08c.131,2.792-.755,3.838-.755,3.838l-2.414.653a5,5,0,0,1-1.692-2.737l-1.4-2.238a.311.311,0,0,1,0-.375",
    transform: "translate(0 -44.747)",
    fill: "#ffb1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12857",
    "data-name": "Trazado 12857",
    d: "M47.621,86.428a5.24,5.24,0,0,0-3.079,1.963,50.157,50.157,0,0,0-3.1,4.883l4.57,4.7,2.09-1.737Z",
    transform: "translate(-31.779 -66.281)",
    fill: "#b7006d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12858",
    "data-name": "Trazado 12858",
    d: "M59.855,86.428l-.4,2.712s-1,3.009-.81,3.777l-1.249,15.875,16.78,1.933-1.1-21.681a4.823,4.823,0,0,0,.028-1.4,1.1,1.1,0,0,0-1.037-.969L68.7,86.508Z",
    transform: "translate(-44.013 -66.281)",
    fill: "#b7006d"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_102",
    "data-name": "L\\xEDnea 102",
    x2: 0.221,
    y2: 4.941,
    transform: "translate(29.255 26.389)",
    fill: "none",
    stroke: "#09090b",
    strokeWidth: 0.775
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_103",
    "data-name": "L\\xEDnea 103",
    y1: 5.058,
    x2: 0.398,
    transform: "translate(14.229 26.635)",
    fill: "none",
    stroke: "#09090b",
    strokeWidth: 0.775
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12859",
    "data-name": "Trazado 12859",
    d: "M93.189,70.77,93,66.2l-3.6-.1-.219,5.363c-.024.587.486.481,1.072.451l1.986-.1a1,1,0,0,0,.947-1.038",
    transform: "translate(-68.394 -50.688)",
    fill: "#ffb1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12860",
    "data-name": "Trazado 12860",
    d: "M90.68,67.486l3.6,2.114-.124-3.067Z",
    transform: "translate(-69.542 -51.024)",
    fill: "#4a280d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12861",
    "data-name": "Trazado 12861",
    d: "M113.914,48.128c0,.745-.332,1.348-.741,1.348s-.741-.6-.741-1.348.331-1.348.741-1.348.741.6.741,1.348",
    transform: "translate(-86.224 -35.875)",
    fill: "#ffb1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12862",
    "data-name": "Trazado 12862",
    d: "M76.929,48.128c0,.745.373,1.348.833,1.348s.833-.6.833-1.348-.373-1.348-.833-1.348-.833.6-.833,1.348",
    transform: "translate(-58.996 -35.875)",
    fill: "#ffb1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12863",
    "data-name": "Trazado 12863",
    d: "M88.578,28.227a18.728,18.728,0,0,1-.5,4.254,3.71,3.71,0,0,1-1.891,2.33l-.174.1a3.362,3.362,0,0,1-3.38.038,3.724,3.724,0,0,1-2-2.488,27.364,27.364,0,0,1-.455-4.239,3.81,3.81,0,0,1,4.14-4.254,3.991,3.991,0,0,1,4.26,4.254",
    transform: "translate(-61.481 -18.384)",
    fill: "#ffb1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12864",
    "data-name": "Trazado 12864",
    d: "M77.934,33.09s.956-3.082.264-5.075c0,0-2.67.767-.264,5.075",
    transform: "translate(-58.996 -21.485)",
    fill: "#4a280d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12865",
    "data-name": "Trazado 12865",
    d: "M113.115,33.09s-1.206-3.082-.514-5.075c0,0,2.493.615.514,5.075",
    transform: "translate(-86.189 -21.485)",
    fill: "#4a280d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12866",
    "data-name": "Trazado 12866",
    d: "M82.511,24.075a1.542,1.542,0,0,1,2.139-.616,6.25,6.25,0,0,0,5.184.888l-.326-1.662a4.923,4.923,0,0,0-7.211,0Z",
    transform: "translate(-63.113 -16.162)",
    fill: "#4a280d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12867",
    "data-name": "Trazado 12867",
    d: "M82.288,86.428l-2.128.026s-.228,2.156,3.925,2.262,4.223-2.124,4.223-2.124l-2.247-.164Z",
    transform: "translate(-61.473 -66.281)",
    fill: "#ffb1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12868",
    "data-name": "Trazado 12868",
    d: "M85.806,38.318c0,.664-2.307,1.2-5.153,1.2s-5.154-.538-5.154-1.2,2.307-1.2,5.154-1.2,5.153.538,5.153,1.2",
    transform: "translate(-57.9 -28.463)",
    fill: "#98045b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12869",
    "data-name": "Trazado 12869",
    d: "M80.653,18.155A5.377,5.377,0,0,0,75.5,23.73H85.806a5.377,5.377,0,0,0-5.153-5.575",
    transform: "translate(-57.9 -13.923)",
    fill: "#b7006d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12870",
    "data-name": "Trazado 12870",
    d: "M86.356,94.211c1.9.069,3.5-3.347,3.661-7.692l-.49-.01c-.142,3.933-1.587,7.267-3.153,7.21s-2.77-3.387-2.63-7.273l-.492-.018c-.155,4.3,1.207,7.715,3.1,7.783",
    transform: "translate(-63.836 -66.281)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22499",
    "data-name": "Rect\\xE1ngulo 22499",
    width: 4.431,
    height: 3.748,
    transform: "translate(20.486 32.29) rotate(-87.929)",
    fill: "#f1f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12871",
    "data-name": "Trazado 12871",
    d: "M93.985,126.081a.994.994,0,1,1-.957-1.029.994.994,0,0,1,.957,1.029",
    transform: "translate(-70.552 -95.901)",
    fill: "#cccbcb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22500",
    "data-name": "Rect\\xE1ngulo 22500",
    width: 1.011,
    height: 1.011,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 26.365, 26.635)",
    fill: "#f1f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12872",
    "data-name": "Trazado 12872",
    d: "M63.271,86.509s1.587,9.978-4.151,17.223l.138-1.753A25.886,25.886,0,0,0,62.4,86.509Z",
    transform: "translate(-45.339 -66.343)",
    fill: "#333"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCapacitadores);
export default __webpack_public_path__ + "static/media/icono_capacitadores.9aa3139e340228472ad8f2d65298c0f2.svg";
export { ForwardRef as ReactComponent };